'use strict';

const mailing = [
  '$state',

  function ($state) {
    return {
      handleRedirect: function (params) {
        var redirectTo;

        switch(params.page) {
        case 'support':
          redirectTo = 'info.contact';
          break;

        case 'privacy-policy':
          redirectTo = 'info.privacy';
          break;

        case 'terms-and-conditions':
          redirectTo = 'info.terms';
          break;

        case 'guide-tips':
          redirectTo = 'info.adviceForGuide';
          break;

        case 'guest-tips':
          redirectTo = 'info.bookingAdvice';
          break;

        default:
          redirectTo = 'intro';
          break;
        }

        $state.go(redirectTo);
      }
    };
  }
];

export default mailing;



// WEBPACK FOOTER //
// ./app/src/modules/mailing/mailing.service.js